import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Eye, DollarSign, MousePointer, CopyCheck, TicketPercent, MessageCircleMore, Users, SquareUserRound } from "lucide-react";
export var InstagramMediaPortal = function (_a) {
    var mediaPreview = _a.mediaPreview, previewPos = _a.previewPos, formatHour = _a.formatHour;
    useEffect(function () {
        if (mediaPreview && window.navigator.vibrate) {
            window.navigator.vibrate(30); // vibra por 30ms
        }
    }, [mediaPreview]);
    if (!mediaPreview || !mediaPreview.image_base64)
        return null;
    // Ajuste dinâmico para não sair da tela
    var tooltipWidth = 300;
    var tooltipHeight = 340;
    var padding = 24;
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var left = previewPos.x + 16;
    var top = previewPos.y + 16;
    if (left + tooltipWidth + padding > winW) {
        left = winW - tooltipWidth - padding;
    }
    if (top + tooltipHeight + padding > winH) {
        top = winH - tooltipHeight - padding - 200;
    }
    if (left < padding)
        left = padding;
    if (top < padding)
        top = padding;
    return ReactDOM.createPortal(React.createElement("div", { style: {
            position: "fixed",
            left: left,
            top: top,
            zIndex: 99999,
            pointerEvents: "none",
        } },
        React.createElement("div", { className: "rounded-lg shadow-xl bg-gray-900/95 border border-pink-400 px-4 py-3", style: {
                minWidth: 220,
                maxWidth: 300,
                color: "#f3f3f3",
                fontFamily: "Inter, sans-serif",
            } },
            React.createElement("img", { src: "data:image/jpeg;base64,".concat(mediaPreview.image_base64), alt: "Capa", style: {
                    width: 200,
                    objectFit: "cover",
                    borderRadius: 8,
                    boxShadow: "0 4px 24px #000a",
                    border: "2px solid #fff",
                    marginBottom: 8,
                } }),
            React.createElement("div", { className: "mb-1 font-bold text-pink-400 text-base leading-tight" }, mediaPreview.copyStart ? "Post" : "Story"),
            React.createElement("div", { className: "flex flex-col gap-1 text-sm" },
                mediaPreview.type && (React.createElement("div", null,
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Tipo:"),
                    React.createElement("span", { className: "ml-1 font-bold text-pink-300" }, mediaPreview.type))),
                mediaPreview.timestamp && (React.createElement("div", null,
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Hor\u00E1rio:"),
                    React.createElement("span", { className: "ml-1 font-bold" }, formatHour(mediaPreview.timestamp)))),
                mediaPreview.copyStart && (React.createElement("div", { className: "italic text-gray-300 mb-1" }, (mediaPreview.copyStart.length > 40
                    ? mediaPreview.copyStart.slice(0, 40) + "..."
                    : mediaPreview.copyStart))),
                mediaPreview.reach !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "alcance", style: { fontSize: 17 } }, "\uD83D\uDC41\uFE0F"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Impress\u00F5es:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.reach))),
                mediaPreview.likes !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "curtidas", style: { fontSize: 17 } }, "\u2764\uFE0F"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Curtidas:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.likes))),
                mediaPreview.comments !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "coment\u00E1rios", style: { fontSize: 17 } }, "\uD83D\uDCAC"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Coment\u00E1rios:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.comments))),
                mediaPreview.shares !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "compartilhamentos", style: { fontSize: 17 } }, "\u2197\uFE0F"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Compartilhamentos:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.shares))),
                mediaPreview.profile_visits !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "visitas perfil", style: { fontSize: 17 } }, "\uD83D\uDDBC\uFE0F"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Visitas ao perfil:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.profile_visits))),
                mediaPreview.navigation !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "navega\u00E7\u00F5es", style: { fontSize: 17 } }, "\uD83D\uDD04"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Navega\u00E7\u00F5es:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.navigation))),
                mediaPreview.replies !== undefined && (React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { role: "img", "aria-label": "respostas", style: { fontSize: 17 } }, "\uD83D\uDCAC"),
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Respostas:"),
                    React.createElement("b", { className: "ml-1" }, mediaPreview.replies)))))), document.body);
};
export var FacebookCampaignPortal = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var facebookPreview = _a.facebookPreview, facebookPreviewPos = _a.facebookPreviewPos;
    if (!facebookPreview)
        return null;
    // Ajuste dinâmico para não sair da tela
    var tooltipWidth = 340;
    var tooltipHeight = 420;
    var padding = 24;
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var left = facebookPreviewPos.x + 16;
    var top = facebookPreviewPos.y + 16;
    if (left + tooltipWidth + padding > winW) {
        left = winW - tooltipWidth - padding;
    }
    if (top + tooltipHeight + padding > winH) {
        top = winH - tooltipHeight - padding - 34;
    }
    if (left < padding)
        left = padding;
    if (top < padding)
        top = padding;
    return ReactDOM.createPortal(React.createElement("div", { style: {
            position: "fixed",
            left: left,
            top: top,
            zIndex: 99999,
            pointerEvents: "none",
        } },
        React.createElement("div", { className: "rounded-lg shadow-xl bg-gray-900/95 border border-[#2563eb] px-4 py-3", style: {
                minWidth: 260,
                maxWidth: 340,
                color: "#f3f3f3",
                fontFamily: "Inter, sans-serif",
                borderColor: "#2563eb",
            } },
            React.createElement("div", { className: "mb-2 font-bold text-orange-400 text-base leading-tight" }, facebookPreview.campaign_name),
            React.createElement("div", { className: "flex flex-col gap-1 text-sm" },
                React.createElement("div", null,
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Status:"),
                    React.createElement("span", { className: "ml-1 font-bold", style: { color: facebookPreview.status === "ACTIVE" ? "#22c55e" : "#f87171" } }, facebookPreview.status === "ACTIVE" ? "Campanha Ativa" : facebookPreview.status)),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(Eye, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Impress\u00F5es:"),
                    React.createElement("b", null, facebookPreview.impressions),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, facebookPreview.impressions_7d)),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CPM:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.impressions > 0
                            ? (facebookPreview.cost / facebookPreview.impressions * 1000).toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.impressions_7d > 0
                            ? (facebookPreview.cost_7d / facebookPreview.impressions_7d * 1000).toFixed(2).replace('.', ',')
                            : '0,00')),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(MousePointer, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CTR:"),
                    React.createElement("b", null, facebookPreview.impressions > 0
                        ? ((facebookPreview.clicks / facebookPreview.impressions) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, facebookPreview.impressions_7d > 0
                        ? ((facebookPreview.clicks_7d / facebookPreview.impressions_7d) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%')),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(Users, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Alcance:"),
                    React.createElement("b", null, (_b = facebookPreview.reach) !== null && _b !== void 0 ? _b : '-'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, (_c = facebookPreview.reach_7d) !== null && _c !== void 0 ? _c : '-')),
                (facebookPreview.messages > 0 || facebookPreview.messages_7d > 0) && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { className: "my-1 border-gray-700" }),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement(MessageCircleMore, { size: 16, className: "inline mr-1", color: "#fff" }),
                        React.createElement("span", null, "Mensagens:"),
                        React.createElement("b", null, facebookPreview.messages),
                        React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                        React.createElement("b", null, facebookPreview.messages_7d)),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                        React.createElement("span", null, "Custo por mensagem:"),
                        React.createElement("b", null,
                            "R$ ",
                            facebookPreview.messages > 0 ? (facebookPreview.cost / facebookPreview.messages).toFixed(2).replace('.', ',') : '0,00'),
                        React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                        React.createElement("b", null, facebookPreview.messages_7d > 0 ? (facebookPreview.cost_7d / facebookPreview.messages_7d).toFixed(2).replace('.', ',') : '0,00')))),
                (facebookPreview.leads > 0 || facebookPreview.leads_7d > 0) && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { className: "my-1 border-gray-700" }),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement(SquareUserRound, { size: 16, className: "inline mr-1", color: "#fff" }),
                        React.createElement("span", null, "Cadastros:"),
                        React.createElement("b", null, (_d = facebookPreview.leads) !== null && _d !== void 0 ? _d : 0),
                        React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                        React.createElement("b", null, (_e = facebookPreview.leads_7d) !== null && _e !== void 0 ? _e : 0)),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                        React.createElement("span", null, "Custo por cad.:"),
                        React.createElement("b", null,
                            "R$ ",
                            facebookPreview.leads > 0 ? (facebookPreview.cost / facebookPreview.leads).toFixed(2).replace('.', ',') : '0,00'),
                        React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                        React.createElement("b", null, facebookPreview.leads_7d > 0 ? (facebookPreview.cost_7d / facebookPreview.leads_7d).toFixed(2).replace('.', ',') : '0,00')))),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(MousePointer, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Clique no link:"),
                    React.createElement("b", null, facebookPreview.clicks),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, (_f = facebookPreview.clicks_7d) !== null && _f !== void 0 ? _f : 0)),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CPC link:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.clicks > 0
                            ? (facebookPreview.cost / facebookPreview.clicks).toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.clicks_7d > 0
                            ? (facebookPreview.cost_7d / facebookPreview.clicks_7d).toFixed(2).replace('.', ',')
                            : '0,00')),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(MousePointer, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Todos os cliques:"),
                    React.createElement("b", null, (_g = facebookPreview.all_clicks) !== null && _g !== void 0 ? _g : 0),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, (_h = facebookPreview.all_clicks_7d) !== null && _h !== void 0 ? _h : 0)),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CPC Todos:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.all_clicks > 0
                            ? (facebookPreview.cost / facebookPreview.all_clicks).toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ",
                        facebookPreview.all_clicks_7d > 0
                            ? (facebookPreview.cost_7d / facebookPreview.all_clicks_7d).toFixed(2).replace('.', ',')
                            : '0,00')),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Or\u00E7amento:"),
                    React.createElement("b", null,
                        "R$ ", (_k = (_j = facebookPreview.daily_budget) === null || _j === void 0 ? void 0 : _j.toFixed(2).replace('.', ',')) !== null && _k !== void 0 ? _k : '-',
                        "/dia")),
                React.createElement("div", { className: "flex items-center gap-2 mt-1" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Custo:"),
                    React.createElement("b", null,
                        "R$ ", (_l = facebookPreview.cost) === null || _l === void 0 ? void 0 :
                        _l.toFixed(2).replace('.', ',')),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, (_m = facebookPreview.cost_7d) === null || _m === void 0 ? void 0 : _m.toFixed(2).replace('.', ',')))))), document.body);
};
export var GoogleCampaignPortal = function (_a) {
    var _b, _c, _d, _e, _f;
    var googlePreview = _a.googlePreview, googlePreviewPos = _a.googlePreviewPos;
    if (!googlePreview)
        return null;
    // Ajuste dinâmico para não sair da tela
    var tooltipWidth = 340;
    var tooltipHeight = 320;
    var padding = 24;
    var winW = window.innerWidth;
    var winH = window.innerHeight;
    var left = googlePreviewPos.x + 16;
    var top = googlePreviewPos.y + 16;
    if (left + tooltipWidth + padding > winW) {
        left = winW - tooltipWidth - padding;
    }
    if (top + tooltipHeight + padding > winH) {
        top = winH - tooltipHeight - padding - 34;
    }
    if (left < padding)
        left = padding;
    if (top < padding)
        top = padding;
    return ReactDOM.createPortal(React.createElement("div", { style: {
            position: "fixed",
            left: left,
            top: top,
            zIndex: 99999,
            pointerEvents: "none",
        } },
        React.createElement("div", { className: "rounded-lg shadow-xl bg-gray-900/95 border border-[#16a34a] px-4 py-3", style: {
                minWidth: 260,
                maxWidth: 340,
                color: "#f3f3f3",
                fontFamily: "Inter, sans-serif",
                borderColor: "#16a34a",
            } },
            React.createElement("div", { className: "mb-2 font-bold text-orange-400 text-base leading-tight" }, googlePreview.campaign_name),
            React.createElement("div", { className: "flex flex-col gap-1 text-sm" },
                React.createElement("div", null,
                    React.createElement("span", { className: "font-semibold text-gray-300" }, "Status:"),
                    React.createElement("span", { className: "ml-1 font-bold", style: { color: googlePreview.campaign_stopped ? "#f87171" : "#22c55e" } }, googlePreview.campaign_stopped ? "Parada" : "Ativa")),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(Eye, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Impress\u00F5es:"),
                    React.createElement("b", null, (_b = googlePreview.impressions) !== null && _b !== void 0 ? _b : '-'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, googlePreview.impressions_7d)),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(MousePointer, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CTR:"),
                    React.createElement("b", null, googlePreview.impressions > 0
                        ? ((googlePreview.clicks / googlePreview.impressions) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, googlePreview.impressions_7d > 0
                        ? ((googlePreview.clicks_7d / googlePreview.impressions_7d) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%')),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(CopyCheck, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Convers\u00F5es:"),
                    React.createElement("b", null, (_c = googlePreview.conversions) !== null && _c !== void 0 ? _c : '-'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, (_d = googlePreview.conversions_7d) === null || _d === void 0 ? void 0 : _d.toFixed(2).replace('.', ','))),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Custo/Convers\u00E3o:"),
                    React.createElement("b", null,
                        "R$ ",
                        googlePreview.conversions > 0
                            ? (googlePreview.cost / googlePreview.conversions).toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ",
                        googlePreview.conversions_7d > 0
                            ? (googlePreview.cost_7d / googlePreview.conversions_7d).toFixed(2).replace('.', ',')
                            : '0,00')),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(TicketPercent, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Taxa/Convers\u00E3o:"),
                    React.createElement("b", null, googlePreview.clicks > 0
                        ? ((googlePreview.conversions / googlePreview.clicks) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, googlePreview.clicks_7d > 0
                        ? ((googlePreview.conversions_7d / googlePreview.clicks_7d) * 100).toFixed(2).replace('.', ',') + '%'
                        : '0,00%')),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(MousePointer, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Cliques:"),
                    React.createElement("b", null, (_e = googlePreview.clicks) !== null && _e !== void 0 ? _e : '-'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null, googlePreview.clicks_7d)),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "CPC:"),
                    React.createElement("b", null,
                        "R$ ",
                        googlePreview.cpc > 0
                            ? googlePreview.cpc.toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ",
                        googlePreview.clicks_7d > 0
                            ? (googlePreview.cost_7d / googlePreview.clicks_7d).toFixed(2).replace('.', ',')
                            : '0,00')),
                React.createElement("hr", { className: "my-1 border-gray-700" }),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Or\u00E7amento:"),
                    React.createElement("b", null,
                        "R$ ",
                        typeof googlePreview.daily_budget === "number"
                            ? googlePreview.daily_budget.toFixed(2).replace('.', ',')
                            : '-',
                        " /dia")),
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement(DollarSign, { size: 16, className: "inline mr-1", color: "#fff" }),
                    React.createElement("span", null, "Custo:"),
                    React.createElement("b", null,
                        "R$ ",
                        typeof googlePreview.cost === "number"
                            ? googlePreview.cost.toFixed(2).replace('.', ',')
                            : '0,00'),
                    React.createElement("span", { className: "text-gray-400" }, "| 7d:"),
                    React.createElement("b", null,
                        "R$ ", (_f = googlePreview.cost_7d) === null || _f === void 0 ? void 0 :
                        _f.toFixed(2).replace('.', ',')))))), document.body);
};
